var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHighSchool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 480 480",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCB641"
    },
    points: "119.496,456 136.496,456 218.664,321.544 203.816,176 52.184,176 37.336,321.544 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 128,
    style: {
      fill: "#EB805B"
    },
    width: 176,
    height: 48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 8,
    style: {
      fill: "#E66032"
    },
    width: 144,
    height: 120
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 128,
    cy: 264.96,
    r: 23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.982,
    y: 224.031,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 889.509 119.6142)",
    style: {
      fill: "#FCB641"
    },
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M420,280.288c-2.128,0-4.16-0.84-5.656-2.344l-28.28-28.288c-3.128-3.128-3.128-8.184,0-11.312 l28.28-28.288c3-3,8.312-3,11.312,0l28.28,28.288c3.128,3.128,3.128,8.184,0,11.312l-28.28,28.288 C424.16,279.44,422.128,280.288,420,280.288z M403.032,244L420,260.968L436.968,244L420,227.032L403.032,244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEF0D9"
    },
    d: "M8,456L8,456c0-8.84,7.16-16,16-16l0,0c8.84,0,16,7.16,16,16l0,0c0,8.84-7.16,16-16,16l0,0 C15.16,472,8,464.84,8,456z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M24,480c-13.232,0-24-10.768-24-24s10.768-24,24-24s24,10.768,24,24S37.232,480,24,480z M24,448 c-4.416,0-8,3.592-8,8s3.584,8,8,8s8-3.592,8-8S28.416,448,24,448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M306.728,448C377.384,417.656,427,347.4,427,265.752c0-4.416-3.576-8-8-8s-8,3.584-8,8 C411,366.248,329.248,448,228.76,448H40v16h400v-16H306.728z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEF0D9"
    },
    d: "M440,456L440,456c0-8.84,7.16-16,16-16l0,0c8.84,0,16,7.16,16,16l0,0c0,8.84-7.16,16-16,16l0,0 C447.16,472,440,464.84,440,456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M456,480c-13.232,0-24-10.768-24-24s10.768-24,24-24s24,10.768,24,24S469.232,480,456,480z M456,448 c-4.416,0-8,3.592-8,8s3.584,8,8,8s8-3.592,8-8S460.416,448,456,448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEF0D9"
    },
    d: "M224,456L224,456c0-8.84,7.16-16,16-16l0,0c8.84,0,16,7.16,16,16l0,0c0,8.84-7.16,16-16,16l0,0 C231.16,472,224,464.84,224,456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M240,480c-13.232,0-24-10.768-24-24s10.768-24,24-24s24,10.768,24,24S253.232,480,240,480z M240,448 c-4.416,0-8,3.592-8,8s3.584,8,8,8c4.416,0,8-3.592,8-8S244.416,448,240,448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB641"
    },
    d: "M392,32h-16V16c0-4.416-3.576-8-8-8s-8,3.584-8,8v16h-16c-4.424,0-8,3.584-8,8s3.576,8,8,8h16v16 c0,4.416,3.576,8,8,8s8-3.584,8-8V48h16c4.424,0,8-3.584,8-8S396.424,32,392,32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED7765"
    },
    d: "M304,224c-13.232,0-24-10.768-24-24s10.768-24,24-24s24,10.768,24,24S317.232,224,304,224z M304,192 c-4.416,0-8,3.592-8,8s3.584,8,8,8s8-3.592,8-8S308.416,192,304,192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M212.672,184H216c4.424,0,8-3.584,8-8v-48c0-4.416-3.576-8-8-8h-8V8c0-4.416-3.576-8-8-8H56 c-4.424,0-8,3.584-8,8v112h-8c-4.424,0-8,3.584-8,8v48c0,4.416,3.576,8,8,8h3.328L29.376,320.728 c-0.168,1.744,0.216,3.496,1.136,4.984l82.168,134.464c1.448,2.376,4.032,3.824,6.824,3.824h17c2.792,0,5.376-1.448,6.832-3.832 l82.168-134.464c0.912-1.496,1.304-3.24,1.136-4.984L212.672,184z M64,16h128v104h-56V72h16c4.424,0,8-3.584,8-8s-3.576-8-8-8h-48 c-4.424,0-8,3.584-8,8s3.576,8,8,8h16v48H64V16z M48,136h8h144h8v32h-4.184H52.184H48V136z M128,250c8.272,0,15,6.728,15,15 s-6.728,15-15,15s-15-6.728-15-15S119.728,250,128,250z M136,441.48V294.816c13.2-3.552,23-15.512,23-29.824s-9.8-26.264-23-29.816 V208c0-4.416-3.576-8-8-8s-8,3.584-8,8v27.176c-13.2,3.552-23,15.512-23,29.824s9.8,26.264,23,29.816V441.48L45.568,319.664 L59.416,184h137.168l13.84,135.664L136,441.48z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighSchool);
export default __webpack_public_path__ + "static/media/HighSchool.067ddcfca264b58fbe915dad61dd46e4.svg";
export { ForwardRef as ReactComponent };